// import React from "react";

// export default function PrivacyPolicy() {
//   return (
//     <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800">
//       <h1 className="text-4xl font-bold mb-2">Privacy Policy</h1>
//       <p className="text-sm text-gray-500 mb-6">Last updated: July 22, 2025</p>

//       <p className="mb-4">
//         This Privacy Policy describes Our policies and procedures on the
//         collection, use and disclosure of Your information when You use the
//         Service and tells You about Your privacy rights and how the law protects
//         You.
//       </p>
//       <p className="mb-6">
//         We use Your Personal data to provide and improve the Service. By using
//         the Service, You agree to the collection and use of information in
//         accordance with this Privacy Policy.
//       </p>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">Interpretation and Definitions</h2>

//       <h3 className="text-xl font-semibold mb-2">Interpretation</h3>
//       <p className="mb-4">
//         The words of which the initial letter is capitalized have meanings
//         defined under the following conditions. The following definitions shall
//         have the same meaning regardless of whether they appear in singular or
//         in plural.
//       </p>

//       <h3 className="text-xl font-semibold mb-2">Definitions</h3>
//       <p className="mb-2">For the purposes of this Privacy Policy:</p>
//       <ul className="list-disc list-inside space-y-2 mb-6">
//         <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
//         <li><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party...</li>
//         <li><strong>Application</strong> refers to FootFall, the software program provided by the Company.</li>
//         <li><strong>Company</strong> refers to FootFall (also referred to as "We", "Us" or "Our").</li>
//         <li><strong>Country</strong> refers to: Delhi, India</li>
//         <li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
//         <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
//         <li><strong>Service</strong> refers to the Application.</li>
//         <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company.</li>
//         <li><strong>Third-party Social Media Service</strong> refers to any website or social network through which a User can log in.</li>
//         <li><strong>Usage Data</strong> refers to data collected automatically by the Service.</li>
//         <li><strong>You</strong> means the individual using the Service, or the entity on behalf of which they use it.</li>
//       </ul>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">Collecting and Using Your Personal Data</h2>

//       <h3 className="text-xl font-semibold mb-2">Types of Data Collected</h3>
//       <h4 className="text-lg font-semibold mb-2">Personal Data</h4>
//       <p className="mb-2">
//         While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
//       </p>
//       <ul className="list-disc list-inside space-y-1 mb-6">
//         <li>Email address</li>
//         <li>First name and last name</li>
//         <li>Phone number</li>
//         <li>Address, State, ZIP/Postal code, City, Country</li>
//         <li>Usage Data</li>
//       </ul>

//       <h4 className="text-lg font-semibold mb-2">Usage Data</h4>
//       <p className="mb-4">
//         Usage Data is collected automatically when using the Service. It may include IP address, browser type/version, pages visited, visit date/time, duration, device identifiers, and diagnostics.
//       </p>

//       <p className="mb-4">
//         When using a mobile device, additional data may be collected: device type, unique ID, IP address, OS, browser type, etc.
//       </p>

//       <h4 className="text-lg font-semibold mb-2">Information from Third-Party Social Media Services</h4>
//       <p className="mb-2">You may log in through:</p>
//       <ul className="list-disc list-inside mb-4 ml-4">
//         <li>Google</li>
//         {/* <li>Facebook</li>
//         <li>Instagram</li> */}
//       </ul>

//       <p className="mb-4">
//         If You log in via a social media account, we may receive data such as name, email, activities, contacts, etc.
//       </p>

//       <h4 className="text-lg font-semibold mb-2">Information Collected while Using the Application</h4>
//       <p className="mb-2">With Your prior permission, we may collect:</p>
//       <ul className="list-disc list-inside mb-4 space-y-1">
//         <li>Location data</li>
//         <li>Camera/photo library access</li>
//       </ul>
//       <p className="mb-6">
//         This data is used to enhance functionality and can be managed through your device settings.
//       </p>

//       <h3 className="text-xl font-semibold mb-2">Use of Your Personal Data</h3>
//       <ul className="list-disc list-inside mb-6 space-y-2">
//         <li><strong>To provide and maintain the Service</strong></li>
//         <li><strong>To manage Your Account</strong></li>
//         <li><strong>To perform a contract</strong></li>
//         <li><strong>To contact You</strong> via email, phone, or push notifications</li>
//         <li><strong>To send news and offers</strong> (unless opted out)</li>
//         <li><strong>To manage Your requests</strong></li>
//         <li><strong>For business transfers</strong></li>
//         <li><strong>For analysis and improvement</strong></li>
//       </ul>

//       <p className="mb-2">We may also share Your personal data:</p>
//       <ul className="list-disc list-inside mb-6 space-y-1">
//         <li><strong>With Service Providers</strong></li>
//         <li><strong>During business transfers</strong></li>
//         <li><strong>With Affiliates and Partners</strong></li>
//         <li><strong>With other users</strong> (in public areas or via social login)</li>
//         <li><strong>With Your consent</strong></li>
//       </ul>

//       <h3 className="text-xl font-semibold mb-2">Retention of Your Personal Data</h3>
//       <p className="mb-4">
//         Data is retained only as long as necessary. Usage Data may be stored longer for analysis or legal purposes.
//       </p>

//       <h3 className="text-xl font-semibold mb-2">Transfer of Your Personal Data</h3>
//       <p className="mb-6">
//         Data may be processed outside Your jurisdiction. We take appropriate steps to ensure secure transfers.
//       </p>

//       <h3 className="text-xl font-semibold mb-2">Delete Your Personal Data</h3>
//       <p className="mb-2">
//         You may delete or update Your information anytime via your account or by contacting Us.
//       </p>
//       <p className="mb-6">
//         Some information may be retained where required by law.
//       </p>

//       <h3 className="text-xl font-semibold mb-2">Disclosure of Your Personal Data</h3>

//       <h4 className="text-lg font-semibold mb-2">Business Transactions</h4>
//       <p className="mb-4">
//         In case of a merger, acquisition or asset sale, your data may be transferred with notice provided.
//       </p>

//       <h4 className="text-lg font-semibold mb-2">Law Enforcement</h4>
//       <p className="mb-4">
//         We may disclose Your data if required by law or public authorities.
//       </p>

//       <h4 className="text-lg font-semibold mb-2">Other Legal Requirements</h4>
//       <p className="mb-2">We may disclose Your data to:</p>
//       <ul className="list-disc list-inside mb-6 space-y-1">
//         <li>Comply with legal obligations</li>
//         <li>Protect Company rights/property</li>
//         <li>Investigate potential wrongdoing</li>
//         <li>Protect public/user safety</li>
//         <li>Protect against liability</li>
//       </ul>

//       <h3 className="text-xl font-semibold mb-2">Security of Your Personal Data</h3>
//       <p className="mb-6">
//         We use commercially acceptable means to protect Your data but cannot guarantee 100% security.
//       </p>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">Children's Privacy</h2>
//       <p className="mb-2">
//         Our Service does not address anyone under 13. If we learn that data was collected from a child, we will delete it.
//       </p>
//       <p className="mb-6">
//         Consent from a parent may be required in some jurisdictions.
//       </p>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">Links to Other Websites</h2>
//       <p className="mb-4">
//         Our Service may contain third-party links. We are not responsible for their content or privacy policies.
//       </p>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">Changes to this Privacy Policy</h2>
//       <p className="mb-2">
//         We may update this policy. You will be notified via email or on the Service. Check this page periodically.
//       </p>
//       <p className="mb-6">Changes become effective upon posting.</p>

//       <h2 className="text-2xl font-semibold mt-8 mb-4">Contact Us</h2>
//       <p className="mb-2">If you have questions, contact us:</p>
//       <ul className="list-disc list-inside">
//         <li>Email: <a href="mailto:footfall02@gmail.com" className="text-blue-600 underline">footfall02@gmail.com</a></li>
//       </ul>
//     </div>
//   );
// }







import React from "react";
import { useTranslation } from "react-i18next";

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800">
      <h1 className="text-4xl font-bold mb-2">{t("privacyPolicy.title")}</h1>
      <p className="text-sm text-gray-500 mb-6">{t("privacyPolicy.lastUpdated")}</p>

      <p className="mb-4">{t("privacyPolicy.intro1")}</p>
      <p className="mb-6">{t("privacyPolicy.intro2")}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">{t("privacyPolicy.interpretationTitle")}</h2>

      <h3 className="text-xl font-semibold mb-2">{t("privacyPolicy.interpretation")}</h3>
      <p className="mb-4">{t("privacyPolicy.interpretationDesc")}</p>

      <h3 className="text-xl font-semibold mb-2">{t("privacyPolicy.definitions")}</h3>
      <p className="mb-2">{t("privacyPolicy.definitionsIntro")}</p>
      <ul className="list-disc list-inside space-y-2 mb-6">
        {t("privacyPolicy.definitionsList", { returnObjects: true }).map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">{t("privacyPolicy.collectUseTitle")}</h2>

      <h3 className="text-xl font-semibold mb-2">{t("privacyPolicy.typesDataCollected")}</h3>

      <h4 className="text-lg font-semibold mb-2">{t("privacyPolicy.personalData")}</h4>
      <p className="mb-2">{t("privacyPolicy.personalDataDesc")}</p>
      <ul className="list-disc list-inside space-y-1 mb-6">
        {t("privacyPolicy.personalDataList", { returnObjects: true }).map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h4 className="text-lg font-semibold mb-2">{t("privacyPolicy.usageData")}</h4>
      <p className="mb-4">{t("privacyPolicy.usageDataDesc")}</p>
      <p className="mb-4">{t("privacyPolicy.usageDataExtra")}</p>

      <h4 className="text-lg font-semibold mb-2">{t("privacyPolicy.thirdParty")}</h4>
      <p className="mb-2">{t("privacyPolicy.thirdPartyDesc")}</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        {t("privacyPolicy.thirdPartyList", { returnObjects: true }).map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
      <p className="mb-4">{t("privacyPolicy.thirdPartyExtra")}</p>

      <h4 className="text-lg font-semibold mb-2">{t("privacyPolicy.infoUsingApp")}</h4>
      <p className="mb-2">{t("privacyPolicy.infoUsingAppDesc")}</p>
      <ul className="list-disc list-inside mb-4 space-y-1">
        {t("privacyPolicy.infoUsingAppList", { returnObjects: true }).map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
      <p className="mb-6">{t("privacyPolicy.infoUsingAppExtra")}</p>

      <h3 className="text-xl font-semibold mb-2">{t("privacyPolicy.usePersonalData")}</h3>
      <ul className="list-disc list-inside mb-6 space-y-2">
        {t("privacyPolicy.usePersonalDataList", { returnObjects: true }).map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
      <p className="mb-2">{t("privacyPolicy.sharePersonalDataIntro")}</p>
      <ul className="list-disc list-inside mb-6 space-y-1">
        {t("privacyPolicy.sharePersonalDataList", { returnObjects: true }).map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h3 className="text-xl font-semibold mb-2">{t("privacyPolicy.retention")}</h3>
      <p className="mb-4">{t("privacyPolicy.retentionDesc")}</p>

      <h3 className="text-xl font-semibold mb-2">{t("privacyPolicy.transfer")}</h3>
      <p className="mb-6">{t("privacyPolicy.transferDesc")}</p>

      <h3 className="text-xl font-semibold mb-2">{t("privacyPolicy.deleteData")}</h3>
      <p className="mb-2">{t("privacyPolicy.deleteDataDesc1")}</p>
      <p className="mb-6">{t("privacyPolicy.deleteDataDesc2")}</p>

      <h3 className="text-xl font-semibold mb-2">{t("privacyPolicy.disclosure")}</h3>
      <h4 className="text-lg font-semibold mb-2">{t("privacyPolicy.businessTransactions")}</h4>
      <p className="mb-4">{t("privacyPolicy.businessTransactionsDesc")}</p>

      <h4 className="text-lg font-semibold mb-2">{t("privacyPolicy.lawEnforcement")}</h4>
      <p className="mb-4">{t("privacyPolicy.lawEnforcementDesc")}</p>

      <h4 className="text-lg font-semibold mb-2">{t("privacyPolicy.otherLegal")}</h4>
      <p className="mb-2">{t("privacyPolicy.otherLegalIntro")}</p>
      <ul className="list-disc list-inside mb-6 space-y-1">
        {t("privacyPolicy.otherLegalList", { returnObjects: true }).map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h3 className="text-xl font-semibold mb-2">{t("privacyPolicy.security")}</h3>
      <p className="mb-6">{t("privacyPolicy.securityDesc")}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">{t("privacyPolicy.children")}</h2>
      <p className="mb-2">{t("privacyPolicy.childrenDesc1")}</p>
      <p className="mb-6">{t("privacyPolicy.childrenDesc2")}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">{t("privacyPolicy.links")}</h2>
      <p className="mb-4">{t("privacyPolicy.linksDesc")}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">{t("privacyPolicy.changes")}</h2>
      <p className="mb-2">{t("privacyPolicy.changesDesc1")}</p>
      <p className="mb-6">{t("privacyPolicy.changesDesc2")}</p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">{t("privacyPolicy.contact")}</h2>
      <p className="mb-2">{t("privacyPolicy.contactDesc")}</p>
      <ul className="list-disc list-inside">
        <li>
          {t("privacyPolicy.contactEmail")}{" "}
          <a href="mailto:footfall02@gmail.com" className="text-blue-600 underline">
            footfall02@gmail.com
          </a>
        </li>
      </ul>
    </div>
  );
}
